module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1044-58aaa19aa23dd19ba70de85b44c0260b.png";